import flutterCommunication from "services/flutter/flutterCommunication";
import style from "./disconnectNet.module.scss";
import { PropsError } from "./type";
export const DisConnectInternet = ({
  description,
  showExitApp,
  callBack,
}: PropsError) => {
  return (
    <div className={style["_container"]}>
      <div className={style["_container-title"]}>
        <span>S E P A R T A</span>
      </div>
      <div className={style["_container-describtion"]}>
        <span>{description}</span>
      </div>
      <div className={style["_btn-wrap"]}>
        <button
          className={style["_btn"]}
          onClick={() => (callBack ? callBack() : window.location.reload())}
        >
          تلاش دوباره
        </button>
        {showExitApp && (
          <button
            className={style["_btn-close"]}
            onClick={() => flutterCommunication.exitAppWithBtnFromWebView()}
          >
            بستن نرم افزار
          </button>
        )}
      </div>
    </div>
  );
};
